export enum ProductImageLayout {
  NONE = "NONE",
  HERO = "HERO",
  LEFT = "LEFT",
  TOP = "TOP",
}
